module.exports = __webpack_public_path__ + "img/infoQRView1.efa14969.svg";